import React from 'react'

export default function Card({children}) {
  return (
    <div className='p-2 shadow bg-white shadow-slate-500/20 rounded-sm w-full'>
        {children}
    </div>
  )
}
